import { ReactNode } from "react";
import { useBadgeNotifications } from "@/hooks/useBadgeNotifications";

interface BadgeNotificationProviderProps {
  children: ReactNode;
}

/**
 * Provider component that sets up real-time badge notifications
 * Include this high in your component tree (e.g., in App.tsx)
 */
export function BadgeNotificationProvider({ children }: BadgeNotificationProviderProps) {
  // This hook sets up the real-time listeners
  useBadgeNotifications();

  return <>{children}</>;
}

